/** Join class names, dropping falsy values. Lives outside the component file
 *  so React Fast Refresh can still hot-swap the UI primitives. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
